import { render, staticRenderFns } from "./AdminShipmentTable.vue?vue&type=template&id=4696f9d4"
import script from "./AdminShipmentTable.vue?vue&type=script&lang=js"
export * from "./AdminShipmentTable.vue?vue&type=script&lang=js"
import style0 from "./AdminShipmentTable.vue?vue&type=style&index=0&id=4696f9d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports